import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const formatTime = (timestamp: string) =>
  dayjs(timestamp, [
    'YYYY-MM-DD HH:mm:ss.SSS',
    'YYYY-MM-DD HH:mm:ss.SS',
    'YYYY-MM-DD HH:mm:ss.S',
    'YYYY-MM-DD HH:mm:ss'
  ]).format('HH:mm:ss.SSS');

export const formatDate = (value: string) => {
  const date = new Date(value.endsWith('Z') ? value : `${value}Z`);

  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date);
};
